module.exports = __webpack_public_path__ + "img/pic_light@3x.1346499c.png";